import { render, staticRenderFns } from "./MassiveAssistanceGang.vue?vue&type=template&id=5a4a8c42"
import script from "./MassiveAssistanceGang.vue?vue&type=script&lang=js"
export * from "./MassiveAssistanceGang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports